/* ==========================================================================
   VELIORA — Predictive Search
   ========================================================================== */
(function () {
  'use strict';
  let debounceTimer;
  const MIN_QUERY_LENGTH = 2;
  const DEBOUNCE_MS = 250;

  function renderResults(container, data, query) {
    const products = (data.resources && data.resources.results && data.resources.results.products) || [];
    const collections = (data.resources && data.resources.results && data.resources.results.collections) || [];
    const articles = (data.resources && data.resources.results && data.resources.results.articles) || [];

    if (!products.length && !collections.length && !articles.length) {
      container.innerHTML = `<p class="text-muted" data-search-empty>${(window.Veliora.strings && window.Veliora.strings.noResults) || 'No results found for'} "${query}"</p>`;
      return;
    }

    let html = '';
    if (products.length) {
      html += `<div class="search-results__group"><div class="search-results__group-title">Products</div>`;
      html += products
        .map(
          (p) => `
        <a class="search-result" href="${p.url}">
          <div class="search-result__media">${p.featured_image ? `<img src="${p.featured_image.url}" alt="${p.title}" width="60" height="72" loading="lazy">` : ''}</div>
          <div>
            <div class="search-result__title">${p.title}</div>
            <div class="search-result__price">${p.price}</div>
          </div>
        </a>`
        )
        .join('');
      html += `</div>`;
    }
    if (collections.length) {
      html += `<div class="search-results__group"><div class="search-results__group-title">Collections</div>`;
      html += collections.map((c) => `<a class="search-result" href="${c.url}"><div><div class="search-result__title">${c.title}</div></div></a>`).join('');
      html += `</div>`;
    }
    if (articles.length) {
      html += `<div class="search-results__group"><div class="search-results__group-title">Articles</div>`;
      html += articles.map((a) => `<a class="search-result" href="${a.url}"><div><div class="search-result__title">${a.title}</div></div></a>`).join('');
      html += `</div>`;
    }
    container.innerHTML = html;
  }

  function runSearch(input) {
    const query = input.value.trim();
    const resultsContainer = document.querySelector('[data-search-results]');
    const chipsContainer = document.querySelector('[data-search-chips]');
    if (!resultsContainer) return;

    if (query.length < MIN_QUERY_LENGTH) {
      resultsContainer.innerHTML = '';
      if (chipsContainer) chipsContainer.style.display = '';
      return;
    }
    if (chipsContainer) chipsContainer.style.display = 'none';

    fetch(`${window.Shopify?.routes?.root || '/'}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,article&resources[limit]=6&resources[options][unavailable_products]=last`)
      .then((res) => res.json())
      .then((data) => renderResults(resultsContainer, data, query))
      .catch(() => {});
  }

  document.addEventListener('input', (e) => {
    const input = e.target.closest('[data-predictive-search-input]');
    if (!input) return;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => runSearch(input), DEBOUNCE_MS);
  });

  document.addEventListener('click', (e) => {
    const chip = e.target.closest('[data-search-chip]');
    if (!chip) return;
    const input = document.querySelector('[data-predictive-search-input]');
    if (input) {
      input.value = chip.textContent.trim();
      input.focus();
      runSearch(input);
    }
  });

  document.addEventListener('drawer:open', (e) => {
    if (e.target.id === 'search-panel') {
      const input = e.target.querySelector('[data-predictive-search-input]');
      if (input) setTimeout(() => input.focus(), 150);
    }
  });
})();
